import { Crosshair } from "lucide-react";
import React from "react";

interface BackToCitationProps {
	/** Where the citation is, e.g. "p. 12" or "Sheet1!B14". */
	where: string;
	onClick: () => void;
}

/**
 * The way back to what a citation pointed at, for a file opened from one.
 * It floats over the bottom of the preview so it stays in reach however far
 * the reader has scrolled or whichever sheet they have switched to.
 */
const BackToCitation: React.FC<BackToCitationProps> = ({ where, onClick }) => (
	<div className="pointer-events-none absolute inset-x-0 bottom-5 z-20 flex justify-center">
		<button
			type="button"
			onClick={onClick}
			className="pointer-events-auto inline-flex h-9 items-center gap-2 rounded-full border border-[#008782] bg-white px-4 text-[13px] font-medium text-[#004C4B] shadow-md hover:bg-[#E6F3F3]"
		>
			<Crosshair className="h-4 w-4" aria-hidden />
			Back to citation
			<span className="font-normal text-text-muted">{where}</span>
		</button>
	</div>
);

export default BackToCitation;
